import AppRoutes from "./Routes"; // Importing Routes.js
import axios from 'axios';
const token = localStorage.getItem('token');
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

function App() {
    return <AppRoutes />; // ✅ Only render routes
}

export default App;
